// sonar.skip=true
export enum CVE_PORTAL {
  Admin = 'PDA',
  Web = 'PAW',
  Mobile = 'PAM', // NOSONAR
  Student = 'PAW' // NOSONAR
}
